import { InlineChildren } from '@doordash/design-language';
import styled from 'styled-components';
export var PhoneContainer = styled(InlineChildren).attrs(function () {
  return {
    size: InlineChildren.Sizes.XxSmall
  };
}).withConfig({
  displayName: "styles__PhoneContainer",
  componentId: "sc-13lya1u-0"
})(["& > *:first-child{flex-shrink:2;min-width:128px;}& > *:last-child{flex-grow:1;flex-shrink:1;}"]);